<template>
    <BreadCrumb :PageTitle="'Setup - ' + qwilrDefinitionName" />
    <AddQwilrQueryBuilder></AddQwilrQueryBuilder>
    <QwilrDefinitionField :isKey="true" :tableTitle="'Key Fields'"/>
    <QwilrDefinitionField :isKey="false" :tableTitle="'Content Fields'"/>
    <QwilrDefinitionBlock></QwilrDefinitionBlock>
    <QwilrDefinitionTemplate></QwilrDefinitionTemplate>
    <div class="row">
      <div class="col-md-6">
        <button @click="goToMainMenu" class="default-btn transition border-0 fw-medium text-white 
            pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 
            fs-md-15 fs-lg-16 m-5 bg-primary" type="button"> Back </button>
      </div>
    </div>

  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import QwilrDefinitionField from "../../components/Qwilr/QwilrDefinitionField.vue";
  import QwilrDefinitionBlock from "../../components/Qwilr/QwilrDefinitionBlock.vue";
  import QwilrDefinitionTemplate from "../../components/Qwilr/QwilrDefinitionTemplate.vue";
  import { GetQwilrDefinitionById } from '@/core/services/entities/qwilr.service'
  import AddQwilrQueryBuilder from "../../components/Qwilr/AddQwilrQueryBuilder.vue";
  
  export default defineComponent({
    name: "QwilrDefinitionPage",
    components: {
      BreadCrumb,
      QwilrDefinitionField,
      QwilrDefinitionBlock,
      QwilrDefinitionTemplate,
      AddQwilrQueryBuilder
    },
    data(){
      return {
        qwilrDefinitionName:'',
        dataSourceId:0
      }
    },
    methods:{
      async goToMainMenu() {
				this.$router.push({ name: 'qwilrInfoPage'});
      },
      async fetchQwilrDefinitionById() {
        let data = await GetQwilrDefinitionById(this.$route.params.id);
        if(data)
        {
          this.qwilrDefinitionName = data.qwilrDefinitionName;
        }

      },
      handleDataSourceSelected(dataSourceId){
        this.dataSourceId= dataSourceId;
      }
    },
    created() {
      this.fetchQwilrDefinitionById();
    }
  });
  </script>